import { getAtpClusters } from '@ori/global-api-client';
export var getAtpClusterId = async function getAtpClusterId(client, atpClusterId, customerId) {
  if (typeof atpClusterId === 'number') {
    return atpClusterId;
  }
  var _await$getAtpClusters = await getAtpClusters(client, {
      customerId: customerId
    }),
    collection = _await$getAtpClusters.data.collection;
  return collection[0].atpClusterId;
};
//# sourceMappingURL=getAtpClusterId.js.map